import React from "react";
import { NavLink } from "react-router-dom";
import { Gift, Store, BarChart3 } from "lucide-react";

const TABS = [
  ["/admin/promotions", "Promotions", Gift, "promotions"],
  ["/admin/promotions/events", "Trade Shows", Store, "events"],
  ["/admin/promotions/analytics", "Analytics", BarChart3, "analytics"],
];

export const PromoTabs = () => (
  <div className="flex gap-1 border-b border-white/10 overflow-x-auto" data-testid="promo-tabs">
    {TABS.map(([to, label, Icon, key]) => (
      <NavLink key={to} to={to} end data-testid={`promo-tab-${key}`}
        className={({ isActive }) => `flex items-center gap-2 px-4 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${isActive ? "border-amber-400 text-amber-300" : "border-transparent text-slate-400 hover:text-slate-200"}`}>
        <Icon className="w-4 h-4" /> {label}
      </NavLink>
    ))}
  </div>
);
